import { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { useOnScreen, getMotionProps } from 'utils/index';
import Asterisk from '../Asterisk/Asterisk';
import styles from './Plan.module.scss';

const Plan = ({plan, onClick=false, selected, onChange, customPrice, callBackFunctions=false, nth=null, asterisk=false, theme="white", testId="", accessCode=false}) => {

    const [show, setShow] = useState(nth ? false : true)
    const [customPricePlaceholder, setCustomPricePlaceholder] = useState("$0.00")
    const planRef = useRef()
    const isIntersecting = useOnScreen(planRef)
    
    useEffect(()=>{
        if(nth && !show){   
            let timeout = setTimeout(() => {
                setShow(true)
            }, nth * 150);
            
            return () => {
                clearTimeout(timeout)
            }
        }
    }, [isIntersecting, nth, show])

    function handleClick(){
        onClick && onClick(plan)
        if(callBackFunctions){
            for(let func of callBackFunctions){
                func()
            }
        }
    }

    function handleCustomPriceChange(value){
        new RegExp('^[0-9]*(\.[0-9]{0,2})?$').test(value) && onChange(value)
    }

    return ( 
        <div className={`${styles.plan} ${selected && styles["plan-selected"]} ${!show ? styles['plan-hidden'] : ''} ${styles[`plan-${theme}`]} ${plan.isCustom ? styles[`plan-custom`] : ''} ${ selected ? styles.shrink : ''}`} onClick={handleClick} data-testid={testId} ref={planRef}>
            {asterisk && asterisk}
            {plan.salePrice &&
                <Asterisk position={{top: 0, right: 0}} translate={{x: "40%"}} scale={.7}>
                    <div>Special <br />offer!</div>
                </Asterisk>
            }
            <div className={styles.name}>
                {plan.name}
            </div>       
            <div className={styles.pricingInfo}>
                {plan.isCustom ? 
                <div className={`${styles.price} ${styles.customPrice}`}>
                    <input type="number" value={customPrice} placeholder={customPricePlaceholder} onFocus={()=>setCustomPricePlaceholder("")} onBlur={()=>setCustomPricePlaceholder("0.00")} onChange={(e)=>handleCustomPriceChange(e.target.value)} data-testid="customPrice" />
                </div>
                :
                <div className={styles.pricesContainer}>
                    <div className={`${styles.price} ${plan.salePrice ? styles.oldPrice : ''}`}>${plan.price}</div>
                    {plan.salePrice && 
                        <div className={`${styles.price} ${styles.salePrice}`}>${plan.salePrice}</div>
                    }
                </div>
                }
                <div className={styles.period}>per {plan.name === "One Day" ? "day" : plan.period}</div>
            </div>
            {accessCode?.valid &&
            <motion.div 
            className={styles.accessCode}
            {...getMotionProps("slideUp")}
            >
                <div>After Free Trial</div>
            </motion.div>
            }
            {plan.detail && 
            <div className={styles.detail}>
                *{plan.detail}
            </div>
            }
        </div>
     );
}
 
export default Plan;

